// assets/metafield-normalize.js
(function () {
  // Replace literal/escaped <br> with line breaks, and safely allow <strong> tags
  function normalizeMetaFields(root) {
    var sel = '.metafield-multi_line_text_field, .metafield-single_line_text_field';
    var nodes = (root || document).querySelectorAll(sel);
    nodes.forEach(function (el) {
      if (el.dataset._normalized === '1') return; // skip if already handled

      var raw = el.textContent || '';
      if (!raw.trim()) return;

      // Some themes double-escape (< becomes &amp;lt;). Normalize that first.
      raw = raw.replace(/&amp;lt;/gi, '&lt;').replace(/&amp;gt;/gi, '&gt;');

      // Convert encoded <br> variants to literal <br>
      raw = raw
        .replace(/&lt;br\s*\/?&gt;/gi, '<br>')         // &lt;br&gt; , &lt;br/&gt; , &lt;br /&gt;
        .replace(/\u00A0|&nbsp;/g, ' ');             // nbsp to space

      // If literal <br> text made it through, treat it as a newline for readability
      raw = raw.replace(/<br\s*\/?>/gi, '\n');

      // (Optional) allow <strong> if your data includes it (remove these 2 lines if you don't want bold)
      raw = raw.replace(/&lt;strong&gt;/gi, '<strong>')
               .replace(/&lt;\/strong&gt;/gi, '</strong>');

      // Finally, render: turn newlines into <br> so they display as actual breaks
      el.innerHTML = raw.replace(/\r\n|\r|\n/g, '<br />');
      el.dataset._normalized = '1';
    });
  }

  // Run now, after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ normalizeMetaFields(document); });
  } else {
    normalizeMetaFields(document);
  }

  // Re-run if the section is reloaded by the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    normalizeMetaFields(e.target);
  });

  // Re-run when the content inside your collapsible tabs is toggled/updated
  var mo = new MutationObserver(function (muts) {
    // Any time text changes inside the page, try normalizing again (cheap op)
    normalizeMetaFields(document);
  });
  mo.observe(document.documentElement, { childList: true, characterData: true, subtree: true });

  // A couple of delayed passes to catch late hydration
  setTimeout(function(){ normalizeMetaFields(document); }, 100);
  setTimeout(function(){ normalizeMetaFields(document); }, 500);
})();
